import "./scss/style.scss";

import smoothScroll from '../../src/js/components/smooth-scroll';
import lazyLoadImages from '../../src/js/components/lazy-load-images';
import animate from "../../src/js/components/animate";
import slider from "./js/slider";
import formInputAnimate from "./js/input-animation";
import { formHandler } from '../../src/js/components/form';

$(function () {
  lazyLoadImages();
  smoothScroll();
  animate();
  slider();
  formInputAnimate();
  formHandler();

  $('[name="membership_name"]').on('change', function () {
    const membership = $(this).val();
    if (membership) {
      $('.promotion-box__list li').removeClass('active');
      $('li[data-href="' + membership + '"]').addClass('active');
    }
  });
});

$(window).on('scroll', function () {
  lazyLoadImages();
  animate();
});
